// Keep quick-action forms within the visible area when a phone keyboard opens
// or pans the page. The dialog's own sheet remains the scrolling container.
export const SearchActionViewport = {
  mounted() {
    this.window = this.el.ownerDocument.defaultView
    this.viewport = this.window.visualViewport
    this.scheduleFit = () => {
      this.window.cancelAnimationFrame(this.fitFrame)
      this.fitFrame = this.window.requestAnimationFrame(() => this.fit())
    }
    this.window.addEventListener("resize", this.scheduleFit)
    this.viewport?.addEventListener("resize", this.scheduleFit)
    this.viewport?.addEventListener("scroll", this.scheduleFit)
    this.fit()
  },

  updated() {
    this.fit()
  },

  fit() {
    this.el.style.setProperty(
      "--search-viewport-height",
      `${this.viewport?.height ?? this.window.innerHeight}px`,
    )
    this.el.style.setProperty(
      "--search-viewport-top",
      `${this.viewport?.offsetTop ?? 0}px`,
    )
  },

  destroyed() {
    this.window.removeEventListener("resize", this.scheduleFit)
    this.viewport?.removeEventListener("resize", this.scheduleFit)
    this.viewport?.removeEventListener("scroll", this.scheduleFit)
    this.window.cancelAnimationFrame(this.fitFrame)
  },
}
